import Vue from 'vue'
import vClickOutside from 'vue-click-outside'
import { vInputCondition, vInputFormatter } from '~/directive'

Vue.directive('click-outside', vClickOutside)
Vue.directive('input-condition', vInputCondition)
Vue.directive('input-formatter', vInputFormatter)

Vue.use(vClickOutside)
